import React, {useState} from "react";
import "../../Styles/AppCommonReportComponent.css";
import {Button, Col, Form, Modal, Row} from "react-bootstrap";

import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import {md5} from 'js-md5';
import Select from "react-select";
import {getToken} from "../../Utils/Common";
import {getAppEmailTemplate} from "../../Design/AppEmailTemplate";
import {getUserInfo} from "../../API/user";

import {Checkbox} from '@material-ui/core';


const AppCommonReportComponent = (props) => {
    //let projectName = sessionStorage.getItem("projectName")
    const postalAddOptions = [
        {label: "Auftraggeber Address", value: "1"},
        {label: "Planer Address", value: "2"}
    ]
    const [reportFromEmail, setReportFromEmail] = useState('hallo@handwai.com')
    const [reportToEmail, setReportToEmail] = useState("")
    const [reportToEmailOptions, setReportToEmailOptions] = useState([])
    const [subject, setSubject] = useState("")
    const [emailMessage, setEmailMessage] = useState("")
    const [key, setKey] = useState("Email")

    const [loginUserDetails, setLoginUserDetails] = useState({})
    const [postalAddress, setPostalAddress] = useState("Auftraggeber Address")
    const [postType, setPostType] = useState("")
    const [acceptPostCost, setAcceptPostCost] = useState(false)

    React.useEffect(() => {
        console.log(key)
    }, [key])

    React.useEffect(async () => {
        let userDetails = await getUserInfo()
        setLoginUserDetails(userDetails)
        setEmailMessage(getAppEmailTemplate(props.type, props.reportDetails.toFirstName,
            props.reportDetails.toLastName,
            props.projectData.projectName,
            loginUserDetails.fn, loginUserDetails.ln))

        setReportToEmail(props.reportDetails.emailToAddress)
        console.log(props.reportDetails, 121)
        setReportToEmailOptions(props.reportDetails.emailToAddress)
        setSubject(props.type + "_" + props.reportDetails.attachmentName)
    }, [props.reportDetails])


    const options = [
        {label: "Einschreiben Einwurf", value: "r1"},
        {label: "Einschreiben", value: "r2"},
        {label: "Einschreiben eigenhandig", value: "r3"}
    ]

    async function updateSendDetails(actions) {
        console.log(actions, 111)
        let apiBody = {
            token: getToken(),
            data: {
                metaID: props.metaData.dataID,
                actions: actions
            }
        }

        /*let sendD = {
                costs: "",
                acceptCosts: acceptPostCost,
                userFirstName: loginUserDetails.fn,
            userLastName: loginUserDetails.ln,
                sendType: "Email",
                sendDetails: {
                    pdfName: output.pdfName,
                    toEmail: reportToEmail.map(e => {
                        return e.value
                    }),
                    body: emailMessage,
                    subject: subject,
                    fromEmail: reportFromEmail,
                    documentHash: md5(output.pdf.replace("data:application/pdf;filename=generated.pdf;base64,", '')),
                }

                //pdf: output.pdf.split('base64,')[1],
                //savePdf: output.pdf.replace("data:application/pdf;filename=generated.pdf;base64,", ''),
            }*/

        return await fetch(process.env.REACT_APP_BACKEND_API_URI + "mobileappbackend/updatesenddetails", {
            method: 'POST',
            headers: {
                'Content-type': 'application/json',
            },
            body: JSON.stringify(apiBody),
        })
            .then((response) => response.json())
            .catch((error) => {
                console.error('Error:', error);
            })
    }

    async function sendReport() {
        let response = {status: 400}
        if (key === "Post") {
            response = await sendPost()
        } else if (key === "Email") {
            response = await sendEmail()
        } else if (key === "Fax") {
            response = await sendFax()
        }
        return response
    }

    async function sendFax() {
        alert("Fax is currently unavailable")
        return {status: 200}
    }

    async function saveAppReportData(sendType, output) {
        let reportData = {}
        let metaID = ""
        if (props.type === "Stunden-Anmeldung") {
            reportData.anmeldungData = props.stundenReportData
            reportData.abmeldungData = {}
            metaID = reportData.anmeldungData.stundenlohnID
            reportData.metaAndProjectData =
                {
                    projectData: props.projectData,
                    metaData: props.metaData
                }
        }
        else if (props.type === "Stunden-Abmeldung") {
            reportData.anmeldungData = props.completeData.stundenlohnanmeldung,
                reportData.abmeldungData = props.stundenReportData
            metaID = reportData.abmeldungData.stundenlohnID
            reportData.metaAndProjectData =
                {
                    projectData: props.projectData,
                    metaData: props.metaData
                }
        }
        else if (props.type === "Tätigkeit") {
            reportData = props.taetigkeitenData
            metaID = reportData.taetigkeitsberichtDataID
            reportData.metaAndProjectData =
                {
                    projectData: props.projectData,
                    metaData: props.metaData
                }
        }
        else if (props.type === "Tages") {
            reportData.tagesdata = props.tagesData
            reportData.pdfData = props.pdfData
            reportData.pdfAddress = props.projectData.auftraggeberAddress.firma + "\n" +
                props.projectData.auftraggeberAddress.streetName + " " +
                props.projectData.auftraggeberAddress.houseNumber + "\n" +
                props.projectData.auftraggeberAddress.postalCode + " " +
                props.projectData.auftraggeberAddress.cityName
            metaID = props.metaData.dataID
        }
        let apiBody = {
            token: getToken(),
            data: {
                webreportURL: process.env.REACT_APP_FRONTEND_BASE_URI,
                metaID: metaID,
                reportType: props.type,
                sendType: sendType,
                postleitzahl: props.projectData.auftraggeberAddress.postalCode,
                reportData: reportData,
                projectID: props.projectData.projectID,
                orgID: props.projectData.organisationID,
                //sendDetails: sendDetails,
                pdfName: output.pdfName
            }
        }

        let result = await fetch(process.env.REACT_APP_BACKEND_API_URI + "mobileappbackend/createmobileappwebreport", {
            method: 'POST',
            headers: {
                'Content-type': 'application/json',
            },
            body: JSON.stringify(apiBody),
        })
            .then((response) => response.json())
            .catch((error) => {
                console.error('Error:', error);
            })

        //let result = {status: 200, uid: 2314, bucketPDF: 2323423432}
        return result
    }

    async function sendEmail() {
        let output = await props.createTReport({
            type: "not-post",
            anschrift: props.projectData.auftraggeberAddress.firma + "\n" +
                props.projectData.auftraggeberAddress.streetName + " " +
                props.projectData.auftraggeberAddress.houseNumber + "\n" +
                props.projectData.auftraggeberAddress.postalCode + " " +
                props.projectData.auftraggeberAddress.cityName
        })
        if (output.status !== "200") {
            return {status: 400}
        }
        let result = await saveAppReportData("Email", output, "")
        let apiBody = {
            emailDetails: {
                //projectDetails: props.projectData.organisationID + "/" +
                //    props.projectData.projectName + "/" + props.type,
                pdfName: output.pdfName,
                toEmail: reportToEmail.map(e => {
                    return e.value
                }),
                body: {
                    htmltext: emailMessage,
                    thanksname: loginUserDetails.fn + " " + loginUserDetails.ln
                },
                //body:emailMessage,
                subject: subject,
                fromEmail: reportFromEmail,
                pdf: output.pdf.split('base64,')[1],
                savePdf: output.pdf.replace("data:application/pdf;filename=generated.pdf;base64,", ''),
                uid: process.env.REACT_APP_FRONTEND_BASE_URI + "/appwebreport/" + result.uid,
                bucketPDF: result.bucketPDF
            }
        }

        console.log(apiBody,66665544)

        let response = await fetch("https://yave8pixif.execute-api.eu-west-3.amazonaws.com/dev/sendemail", {
            method: 'POST',
            headers: {
                'Content-type': 'application/json'
            },
            body: JSON.stringify(apiBody)
        });

        //update the senddetailsobject

        let actions = {
            costs: "",
            acceptCosts: acceptPostCost,
            userFirstName: loginUserDetails.fn,
            userLastName: loginUserDetails.ln,
            sendType: "Email",
            sendDetails: {
                pdfName: output.pdfName,
                toEmail: reportToEmail.map(e => {
                    return e.value
                }),
                body: {
                    htmltext: emailMessage,
                    thanksname: loginUserDetails.fn + " " + loginUserDetails.ln
                },
                subject: subject,
                fromEmail: reportFromEmail,
                documentHash: md5(output.pdf.replace("data:application/pdf;filename=generated.pdf;base64,", '')),
            }
        }
        result = await updateSendDetails(actions)
        props.setHandleShow(false)
        setReportFromEmail("")
        setReportToEmail([])
        setSubject("")
        setEmailMessage("")
        console.log(response.status)
        return response
    }

    async function sendPost() {
        let completePostalAddress = ""
        if (postalAddress === "Auftraggeber Address") {
            completePostalAddress = props.projectData.auftraggeberAddress.firma + "\n" +
                props.projectData.auftraggeberAddress.streetName + " " +
                props.projectData.auftraggeberAddress.houseNumber + "\n" +
                props.projectData.auftraggeberAddress.postalCode + " " +
                props.projectData.auftraggeberAddress.cityName
        } else if (postalAddress === "Planer Address") {
            completePostalAddress = props.projectData.planerAddress.firma + "\n" +
                props.projectData.planerAddress.streetName + " " +
                props.projectData.planerAddress.houseNumber + " \n" +
                props.projectData.planerAddress.postalCode + " " +
                props.projectData.planerAddress.cityName
        }
        let output = await props.createTReport(
            {
                type: "post",
                anschrift: completePostalAddress
            }
        )
        if (output.status !== "200") {
            return {status: 400}
        }
        let result = await saveAppReportData("Post", output, completePostalAddress)
        //apicall to BE for saving data
        //api call to postal company
        let postApiBody = {
            bucketPDF: result.bucketPDF,
            postDetails: {
                "auth": {
                    "username": "LXPApi54363",
                    "apikey": "7f946863ceda7d1e731c9466d74d70228ee8ec90ad0e3def35e41b794378fd3d",
                    "mode": "test"
                },
                "letter": {
                    "base64_file": output.pdf.replace("data:application/pdf;filename=generated.pdf;base64,", ''),
                    "base64_file_checksum": md5(output.pdf.replace("data:application/pdf;filename=generated.pdf;base64,", '')),
                    "specification": {
                        "color": "4", // 1 - black/white, 4 - color
                        "mode": "simplex", // simplex, duplex
                        "shipping": "national" // national, international, auto
                    },
                    //"registered": postType, // r1, r2, r3
                }
            }
        }
        let response = await fetch("https://yave8pixif.execute-api.eu-west-3.amazonaws.com/dev/sendPost", {
            method: 'POST',
            headers: {
                'Content-type': 'application/json'
            },
            body: JSON.stringify(postApiBody)
        }).then((response) => response.json());
        let actions = {
            costs: "",
            acceptCosts: acceptPostCost,
            userFirstName: loginUserDetails.fn,
            userLastName: loginUserDetails.ln,
            sendType: "Post",
            sendDetails: {
                apiReponse: response,
                specification: {
                    color: "4", // 1 - black/white, 4 - color
                    mode: "simplex", // simplex, duplex
                    shipping: "national" // national, international, auto
                },
                registered: postType, // r1, r2, r3
                anschrift: completePostalAddress,
                documentHash: md5(output.pdf.replace("data:application/pdf;filename=generated.pdf;base64,", '')),
            }
        }

        let updatesenddetails = await updateSendDetails(actions)
        console.log(updatesenddetails, "updatesenddetails")
        props.setHandleShow(false)
        setReportFromEmail("")
        setReportToEmail([])
        setSubject("")
        setEmailMessage("")
        setPostalAddress("")
        console.log(response, "postresponse")
        return response
    }


    return (

        <Modal style={{padding: 20}} show={props.handleShow}>
            <Form className='handwai-dark' style={{padding: 10}}>
                <Modal.Header style={{borderWidth: 0}} className='handwai-dark'>
                    <Modal.Title className='handwai-text-label-main'>Versenden</Modal.Title>
                </Modal.Header>
                <Modal.Body className='handwai-dark'>
                    <Tabs
                        onSelect={(k) => {
                            setKey(k)
                        }}
                        defaultActiveKey={key}
                        id="justify-tab-example"
                        className="mb-3"
                        //class="appReportModal"
                        justify

                    >
                        <Tab eventKey="Email" title="Email">
                            <Form.Group as={Row} className="mb-3" controlId='formTemplateHeadline'>
                                <Form.Label column sm={3} className='handwai-text-label-normal'>Absender</Form.Label>
                                <Col sm={9}>
                                    <Form.Control
                                        className='handwai-input'
                                        type='text'
                                        style={{backgroundColor: "black"}}
                                        disabled={true}
                                        value='hallo@handwai.com'
                                        onChange={() => {
                                            setReportFromEmail('hallo@handwai.com')
                                        }
                                        }
                                    />
                                </Col>
                            </Form.Group>

                            <Form.Group as={Row} className="mb-3" controlId='formTemplateContent'>
                                <Form.Label column sm={3} className='handwai-text-label-normal'>Empfänger</Form.Label>


                                <Col column sm={9}>
                                    <Select options={reportToEmailOptions}
                                            placeholder={"Empfänger auswählen:"}
                                            defaultValue={reportToEmailOptions}
                                            isMulti={true}
                                            onChange={async (e) => {
                                                console.log(e, 11)
                                                setReportToEmail(e)
                                            }
                                            }
                                    />
                                </Col>


                                {/*<Col sm={9}>
                                    <Form.Control
                                        className='handwai-input'
                                        type='email'
                                        placeholder='Geben Sie Empfänger email'
                                        value={reportToEmail}
                                        onChange={(e) => {
                                            setReportToEmail(e.target.value)
                                        }
                                        }
                                    />
                                </Col>*/}
                            </Form.Group>

                            {/*<Form.Group as={Row} className="mb-3" controlId='formTemplateContent'>
                                <Form.Label column sm={3} className='handwai-text-label-normal'>Betreff:</Form.Label>
                                <Col sm={9}>
                                    <Form.Label className='handwai-text-label-normal'>Projekt
                                        | {projectName}</Form.Label>
                                </Col>
                            </Form.Group>*/}

                            <Form.Group as={Row} className="mb-3" controlId='formTemplateContent'>
                                <Form.Label column sm={3} className='handwai-text-label-normal'>Subject</Form.Label>
                                <Col sm={9}>
                                    <Form.Control
                                        className='handwai-input'
                                        type='text'
                                        value={props.type + "_" +
                                        props.reportDetails.attachmentName}
                                        onChange={(e) => {
                                            setSubject(e.target.value)
                                        }
                                        }
                                    />
                                </Col>
                            </Form.Group>

                            <Form.Group as={Row} className="mb-3" controlId='formTemplateContent'>
                                <Form.Label column sm={3} className='handwai-text-label-normal'>Nachricht</Form.Label>
                                <Col sm={9}>
                                    <Form.Control
                                        className='handwai-input'
                                        as='textarea'
                                        rows={4}
                                        value={emailMessage}
                                        onChange={(e) => {

                                            setEmailMessage(e.target.value)
                                        }
                                        }
                                    />
                                </Col>
                            </Form.Group>

                            <Form.Group as={Row} className="mb-3" controlId='formTemplateContent'>
                                <Form.Label column sm={3} className='handwai-text-label-normal'>Anhang:</Form.Label>
                                <Col sm={9}>
                                    <Form.Label className='handwai-text-label-normal'>Projekt
                                        | {props.reportDetails.attachmentName}</Form.Label>
                                </Col>
                            </Form.Group>


                        </Tab>
                        <Tab eventKey="Post" title="Post">

                            <Form.Group as={Row} className="mb-3" controlId='formTemplateContent'>
                                <Form.Label column sm={3} className='handwai-text-label-normal'>Empfänger
                                    Anschrift</Form.Label>
                                <Col column sm={9}>
                                    <Select
                                        style={{backgroundColor: "white"}}
                                        options={postalAddOptions}
                                        placeholder={"Post Empfänger auswählen:"}
                                        defaultValue={[postalAddOptions[0]]}
                                        onChange={(e) => {
                                            setPostalAddress(e.label)
                                        }
                                        }
                                    />
                                </Col>


                                {/*<Col sm={9}>
                                    <Form.Control
                                        className='handwai-input'
                                        type='email'
                                        placeholder='Geben Sie Empfänger email'
                                        value={reportToEmail}
                                        onChange={(e) => {
                                            setReportToEmail(e.target.value)
                                        }
                                        }
                                    />
                                </Col>*/}
                            </Form.Group>


                            <Form.Group as={Row} className="mb-3" controlId='formTemplateContent'>
                                <Form.Label column sm={3} className='handwai-text-label-normal'>Dokument:</Form.Label>
                                <Col sm={9}>
                                    <Form.Label
                                        className='handwai-text-label-normal'>{props.reportDetails.attachmentName}</Form.Label>
                                </Col>
                            </Form.Group>

                            <Form.Group as={Row} className="mb-3" controlId='formTemplateHeadline'>
                                <Form.Label column sm={3} className='handwai-text-label-normal'>Versenden
                                    als</Form.Label>
                                <Col sm={9}>
                                    <Select
                                        style={{backgroundColor: "white"}} options={options} placeholder="Wählen"
                                        defaultValue={postType}
                                        onChange={async (e) => setPostType(e.value)}
                                    />;
                                </Col>
                            </Form.Group>

                            <Form.Group as={Row} className="mb-3" controlId='formTemplateHeadline'>
                                <Form.Label column sm={9} className='handwai-text-label-normal'>
                                    Hier mit Bestätige ich die Kostenübernahme
                                </Form.Label>
                                <Col sm={1}>
                                    <Checkbox
                                        onChange={(e) => {
                                            setAcceptPostCost(e.target.checked)
                                        }}>
                                    </Checkbox>
                                </Col>
                            </Form.Group>

                        </Tab>
                        <Tab eventKey="Fax" title="Fax" disabled={true}>
                            Tab content for Loooonger Tab
                        </Tab>
                    </Tabs>

                </Modal.Body>
                <Modal.Footer style={{borderWidth: 0}} className='handwai-dark'>
                    <Button className='handwai-btn-login' variant='primary'
                            onClick={async () => {
                                if (key === "Post" && !acceptPostCost) {
                                    alert("Bitte bestätigen die Kostenübernahme")
                                } else {
                                    let response = await sendReport()
                                    if (response.status === 200) {
                                        alert(key + " Sent succesfully")
                                        props.setHandleShow(false)
                                        setKey("Email")
                                        setReportFromEmail("")
                                        setReportToEmail([])
                                        setSubject("")
                                        setEmailMessage("")
                                        setPostalAddress("")
                                    } else {
                                        alert("Please fill all data/Sending error")
                                    }
                                }
                            }
                            }>
                        Senden
                    </Button>
                    <Button className='handwai-btn-logout'
                            onClick={() => {
                                props.setHandleShow(false)
                                setKey("Email")
                                setReportFromEmail([])
                                setReportToEmail([])
                                setSubject("")
                                setEmailMessage("")
                                setPostalAddress("")
                            }}>
                        Abbrechen
                    </Button>


                    {/*<Button className='handwai-btn-logout'
                            href={process.env.REACT_APP_FRONTEND_PATH_APPWEBREPORT}
                    >
                        Abbrechen
                    </Button>*/}
                </Modal.Footer>
            </Form>
        </Modal>

    );

}


export default AppCommonReportComponent;